<script lang="ts">
    // Stores Shared
    import { sidebarIsHidden } from '@amp/web-app-components/src/stores/sidebar-hidden';

    // Components
    import DefaultPage from '~/components/pages/DefaultPage.svelte';
    import PageHeader from '~/components/jet/header/PageHeader.svelte';
    import Section from '~/jet/components/Section.svelte';
    import SearchInput from '~/components/structure/header/SearchInput.svelte';

    // Types
    import type { SearchPage } from '@jet-app/music-classical/models/pages/search';
    import type { FlowAction } from '~/jet/models';

    // Utils
    import { getJet } from '~/jet';

    // Stores
    import { currentTab } from '~/stores/current-tab';

    export let page: SearchPage;

    const jet = getJet();
    let suggestionsVisible = false;
    let renderTrigger = 0;

    const onShowSearchSuggestions = () => {
        suggestionsVisible = true;
    };

    const toggleSuggestionsVisibility = async () =>
        (suggestionsVisible = !suggestionsVisible);

    const onClear = (e: CustomEvent<FlowAction>) => {
        toggleSuggestionsVisibility();
        renderTrigger++;

        if (page?.term) {
            jet.perform(e.detail);
        }
    };
</script>

<div class="search-page-container" data-testid="search-page">
    <!-- Mobile Search Page -->
    {#if $sidebarIsHidden}
        <PageHeader header={page.header} />
        <SearchInput
            {currentTab}
            defaultValue={page.term ?? ''}
            on:showSearchSuggestions={onShowSearchSuggestions}
            on:clickedOutside={() => toggleSuggestionsVisibility()}
            on:clear={onClear}
        />

        {#if !suggestionsVisible}
            {#each page.sections?.filter(Boolean) as section}
                <Section {section} />
            {/each}
        {/if}
    {:else}
        <!-- Default to DefaultPage for Desktop Search Screens when sidebar is visible -->
        <DefaultPage {page} />
    {/if}
</div>

<style lang="scss">
    .search-page-container {
        background-color: initial;
    }
</style>
